import { Component, OnInit, OnDestroy, AfterViewInit, ElementRef, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { SeguridadService } from '../_services/seguridad.service'
import { Subscription } from 'rxjs/Subscription';

import { PreguntasService } from '../_services/preguntas.service';

import { GlobalEventsManager } from "../_services/globaleventsmanager.service";
import { NormasService } from '../_services/normas.service';
import { EvidenciasService } from '../_services/evidencias.service';
import { EmpresasService } from '../_services/empresas.service';

import {ConfirmDialogModule,ConfirmationService} from 'primeng/primeng';

declare var jQuery: any;

@Component({
    selector: 'evidenciasin',
    templateUrl: 'evidenciasin.template.html'
})
export class EvidenciasINComponent implements OnInit, OnDestroy, AfterViewInit {

    @ViewChild('tooltip') tooltip: ElementRef;

    accion: string;
    subscription: Subscription;
    public filterQuery = "";
    public filterQueryEvidencias = "";
    listaenlaces: any=[];

    listanormas: any = [];
    listanormasfiltro: any = [];

    listanormasreducida: any=[];
    listanormasampliada: any=[];

    puedoeditarevidencia: boolean;

    listaevidencias: any=[];
    listaEvidenciasFiltros: any=[]

    normaseleccionada: number = 0;
    evidenciaseleccionada: number = 0;

    detallenorma: boolean = true;
    detalleevidencia: boolean = true;
    formevidencia: boolean = false;

    etiquetaevidencia: string = "";

    iconocerrar: string = 'fa fa-times';
    iconoexpandir: string = 'fa fa-expand';

    copiaevidencia: boolean = false;

    titulonormaenlaces: string = "";


    filtroetiquetas: string = "xxxxxxx"; //forzamos así que no encuentre resultados en el listado
    nuevaetiqueta: string = "";
    listaetiquetas: any = [];
    listaetiquetasfiltro: any = [];
    finalizado: boolean = false;
    revisado: boolean = false;
    listaAmbitos: any = [];

    verfiltros: boolean = false;
    listamarcos: any = [];
    listapaises: any = [];
    listacomunidades: any = [];
    listaprovincias: any = [];
    listamunicipios: any = [];
    filtro_id_ambito: number = 0;
    filtro_id_ambito_internacional: number = 0;
    filtro_id_ambito_nacional: number = 0;
    filtro_id_ambito_autonomico: number = 0;
    filtro_id_ambito_provincial: number = 0;
    filtro_id_ambito_local: number = 0;
    listabloques: any = [];
    listaareas: any = [];
    listamodulos: any = [];
    filtro_id_bloque: number = 0;
    filtro_id_area: number = 0;
    filtro_id_modulo: number = 0;

    constructor(private seguridad: SeguridadService,
        private router: Router,
        //private service: PreguntasService,
        private empresasService: EmpresasService,
        private normasService: NormasService,
        private evidenciasService: EvidenciasService,
        private globalEventsManager: GlobalEventsManager,
        private confirmationService: ConfirmationService,
        private activatedRoute: ActivatedRoute) {

        this.accion = activatedRoute.snapshot.params["accion"];

    }

    ngOnInit() {

      this.seguridad.getLogado();

      this.subscription = this.seguridad.dejoPasarUsuarioEmitter.subscribe((mode) => {
          if (mode !== null) {
              if (!mode) {
                  this.router.navigate(['login']);
              }
          }
      });

      this.globalEventsManager.menuExtendido(true);


      let breadcrumb: any = [
        {
          'path':'#',
          'name': 'Inventario de normas'
        }];

      this.globalEventsManager.setNombrePagina(breadcrumb);

      this.getListaNormas();
      this.getListaNormasReducida();

      this.getListaEtiquetas();
      this.getListaAmbitos();

      this.getListaMarcos();
      this.getListaPaises();
      this.getListaComunidades();

      this.getListaBloques();

    }

    ngAfterViewInit() {

    }

    ngOnDestroy() {
      this.subscription.unsubscribe();
    }

    getListaNormas() {
      this.normasService.getListaInventarioDeNormas().subscribe(
          data => {
            if (data){

              this.listanormasampliada = data.json().lista;
              this.listanormas = this.listanormasampliada;



              //formateamos el ambito de las normas
              for (let norma of this.listanormas){

                norma.descAmbito = norma.ambitoCalc;

                /*if (norma.id_ambito == 7){
                  norma.descAmbito = norma.marco;
                }
                if (norma.id_ambito == 6){
                  norma.descAmbito = norma.localidad;
                }
                if (norma.id_ambito == 3){
                  norma.descAmbito = norma.provincia;
                }
                if (norma.id_ambito == 2){
                  norma.descAmbito = norma.autonomia;
                }
                if (norma.id_ambito == 1){
                  norma.descAmbito = norma.pais;
                }*/
              }


              this.listanormasfiltro = JSON.parse(JSON.stringify(this.listanormas));

              console.log(data.json().lista);
            }
          }
      );
    }

    getListaNormasReducida() {
      this.normasService.getListaNormas().subscribe(
          data => {
            if (data){
              this.listanormasreducida = data.json().lista;
            }
          }
      );
    }



    mostrarEnlaces(enlaces: any, titulo: string) {
      this.listaenlaces = enlaces;
      this.titulonormaenlaces = titulo;
    }


    verNorma(id_norma: number){

      if (id_norma != 0){

        this.listanormas = this.listanormasreducida;

        this.resetEvidencia();
        this.detallenorma = false;
        this.normaseleccionada = id_norma;
        this.getListaEvidencias(this.normaseleccionada);

        this.scrollLienzo();
      }
    }

    nuevaEvidencia(){
      this.editarEvidencia(0);
    }

    borrarEvidencia(id_evidencia: number){

      this.evidenciasService.deleteEvidencia(id_evidencia).subscribe(
        data => {
          if (data){
            this.getListaEvidencias(this.normaseleccionada);
          }
        }
      );
    }

    cerrarEvidencia(){

    }

    resetEvidencia(){
      this.listaevidencias = [];
      this.evidenciaseleccionada = 0;
      this.formevidencia = false;
      this.detalleevidencia = true;
    }

    visualizarEvidencia(id_evidencia: number){
      this.copiaevidencia = false;
      this.puedoeditarevidencia = false;
      this.getEditarEvidencia(id_evidencia);
    }

    editarEvidencia(id_evidencia:number){
      this.copiaevidencia = false;
      this.puedoeditarevidencia = true;
      this.getEditarEvidencia(id_evidencia);
    }

    copiarEvidencia(id_evidencia:number){
      this.copiaevidencia = true;
      this.puedoeditarevidencia = true;
      this.getEditarEvidencia(id_evidencia);
    }

    getEditarEvidencia(id_evidencia: number){
      if (id_evidencia != 0){
        this.etiquetaevidencia = "Editar Evidencia";
      }else{
        this.etiquetaevidencia = "Nueva Evidencia";
      }
      this.detalleevidencia = false;
      this.evidenciaseleccionada = id_evidencia;
      this.formevidencia = true;

      this.scrollLienzo();
    }

    getListaEvidencias(id_norma: number) {
      this.evidenciasService.getListaEvidenciasNorma(id_norma).subscribe(
          data => {
            if (data){

              this.listaevidencias = data.json().lista;
              this.listaEvidenciasFiltros = data.json().lista;
            }
          }
      );
    }

    onChangeEvidencia(event){
      //if(event){
      if(event.anadir == false){
        this.cerrar(2);
        this.getListaEvidencias(this.normaseleccionada);
      }else{
        this.getListaEvidencias(this.normaseleccionada);
      }
    }

    onCloseEvidencia(event: number){
      this.cerrar(event);
    }


    cerrar(nivel:number){

      //le pasamos el nivel al que tiene que ir

      if (nivel <= 1){
        this.normaseleccionada = 0;
        this.detallenorma = true;
        this.listanormas = this.listanormasampliada;
        this.formevidencia = false;
      }

      if (nivel <= 2){
        this.evidenciaseleccionada = 0;
        this.detalleevidencia = true;
        this.formevidencia = false;
      }

      this.scrollLienzo();

    }

    expandir(nivel:number){
      if (nivel == 1){
        if(this.detallenorma){
          this.detallenorma = false
          this.listanormas = this.listanormasreducida;
        }else{
          this.detallenorma = true;
          this.listanormas = this.listanormasampliada;
        }
      }
      if (nivel == 2){
        (this.detalleevidencia) ? this.detalleevidencia = false : this.detalleevidencia = true;
      }
    }

    scrollLienzo(){
      jQuery(".wrap-app").animate({scrollLeft: 5000}, 1000);
    }

    stripText(val: string){
      var cadena: string = "";

      if (val != null){
        if (val.length>25){
          cadena = val.substr(0, 25)+"...";
        }else{
          cadena = val;
        }
      }

      return cadena;
    }

    confirm(id_evidencia: number) {
        this.confirmationService.confirm({
            message: '¿Seguro que deseas eliminar la evidencia?',
            accept: () => {
                this.borrarEvidencia(id_evidencia);
            }
        });
    }

    getListaEtiquetas(){
      this.normasService.getListaEtiquetasNorma().subscribe(
        data => {
          if (data){
            this.listaetiquetas = data.json().lista;
          }
        }
      );
    }

    getListaAmbitos(){
      this.normasService.getListaAmbitos().subscribe(
        data => {
          if (data){
            this.listaAmbitos = data.json().lista;
          }
        }
      );
    }

    filtroEtiquetas(){
      if (this.nuevaetiqueta.length > 1){
        this.filtroetiquetas = this.nuevaetiqueta;
      }else{
        this.filtroetiquetas = "xxxxxxx";
      }
    }

    anadirEtiqueta(){
      this.listaetiquetasfiltro.push(this.nuevaetiqueta);
      this.nuevaetiqueta = "";
      this.filtroEtiquetas();
      this.aplicarFiltros();
    }

    eliminarEtiqueta(index: number){
      this.listaetiquetasfiltro.splice(index,1);
      this.aplicarFiltros();
    }

    aplicarFiltros(){

      let auxnormas = this.listanormas;

      this.listanormasfiltro = [];

      //recorremos los filtros de las etiquetas para restringir el array de normas
      if (this.listaetiquetasfiltro.length > 0){
        for (let norma of this.listanormas){

          let aux = 1;

          for (let eti of this.listaetiquetasfiltro){

            if (norma.etiquetas.length > 0){

              let encontrado = 0;

              for (let etiqueta of norma.etiquetas){
                if (etiqueta.descripcion == eti){
                  encontrado = 1;
                }
              }

              if (encontrado == 0){
                aux = 0;
              }

            }else{
              aux = 0;
            }

          }

          if (aux == 1){
            this.listanormasfiltro.push(norma);
          }

        }
      }else{
        this.listanormasfiltro = auxnormas;
      }

      auxnormas = this.listanormasfiltro;
      //********************* fin filtro etiquetas **************************

      /*********************** filtro revisado y finalizado ******************/

      if(this.finalizado){
        this.listanormasfiltro = [];
        for (let norma of auxnormas){
          if (norma.finalizado == 1){
            this.listanormasfiltro.push(norma);
          }
        }
      }else{
        this.listanormasfiltro = auxnormas;
      }
      auxnormas = this.listanormasfiltro;

      if(this.revisado){
        this.listanormasfiltro = [];
        for (let norma of auxnormas){
          if (norma.revisado == 1){
            this.listanormasfiltro.push(norma);
          }
        }
      }else{
        this.listanormasfiltro = auxnormas;
      }
      auxnormas = this.listanormasfiltro;
      /*********************** filtro revisado y finalizado ******************/

      /*********************** filtro ambitos ********************************/

      if (this.filtro_id_ambito != 0){
        this.listanormasfiltro = [];
        for (let norma of auxnormas){
          if (norma.id_ambito == this.filtro_id_ambito){
            this.listanormasfiltro.push(norma);
          }
        }
      }else{
        this.listanormasfiltro = auxnormas;
      }

      auxnormas = this.listanormasfiltro;

      if (this.filtro_id_ambito_internacional != 0){
        this.listanormasfiltro = [];
        for (let norma of auxnormas){
          if (norma.id_ambito_internacional == this.filtro_id_ambito_internacional){
            this.listanormasfiltro.push(norma);
          }
        }
      }else{
        this.listanormasfiltro = auxnormas;
      }

      auxnormas = this.listanormasfiltro;

      if (this.filtro_id_ambito_nacional != 0){
        this.listanormasfiltro = [];
        for (let norma of auxnormas){
          if (norma.id_ambito_nacional == this.filtro_id_ambito_nacional){
            this.listanormasfiltro.push(norma);
          }
        }
      }else{
        this.listanormasfiltro = auxnormas;
      }

      auxnormas = this.listanormasfiltro;

      if (this.filtro_id_ambito_autonomico != 0){
        this.listanormasfiltro = [];
        for (let norma of auxnormas){
          if (norma.id_ambito_autonomico == this.filtro_id_ambito_autonomico){
            this.listanormasfiltro.push(norma);
          }
        }
      }else{
        this.listanormasfiltro = auxnormas;
      }

      auxnormas = this.listanormasfiltro;


      if (this.filtro_id_ambito_provincial != 0){
        this.listanormasfiltro = [];
        for (let norma of auxnormas){
          if (norma.id_ambito_provincial == this.filtro_id_ambito_provincial){
            this.listanormasfiltro.push(norma);
          }
        }
      }else{
        this.listanormasfiltro = auxnormas;
      }

      auxnormas = this.listanormasfiltro;


      if (this.filtro_id_ambito_local != 0){
        this.listanormasfiltro = [];
        for (let norma of auxnormas){
          if (norma.id_ambito_local == this.filtro_id_ambito_local){
            this.listanormasfiltro.push(norma);
          }
        }
      }else{
        this.listanormasfiltro = auxnormas;
      }

      auxnormas = this.listanormasfiltro;
      /*********************** filtro ambitos ********************************/

      /********************** filtro bloques ********************************/
      if (this.filtro_id_bloque != 0){
        this.listanormasfiltro = [];
        for (let norma of auxnormas){
          if (norma.id_bloque == this.filtro_id_bloque){
            this.listanormasfiltro.push(norma);
          }
        }
      }else{
        this.listanormasfiltro = auxnormas;
      }

      auxnormas = this.listanormasfiltro;

      if (this.filtro_id_area != 0){
        this.listanormasfiltro = [];
        for (let norma of auxnormas){
          if (norma.id_area == this.filtro_id_area){
            this.listanormasfiltro.push(norma);
          }
        }
      }else{
        this.listanormasfiltro = auxnormas;
      }

      auxnormas = this.listanormasfiltro;

      if (this.filtro_id_modulo != 0){
        this.listanormasfiltro = [];
        for (let norma of auxnormas){
          if (norma.id_modulo == this.filtro_id_modulo){
            this.listanormasfiltro.push(norma);
          }
        }
      }else{
        this.listanormasfiltro = auxnormas;
      }

      auxnormas = this.listanormasfiltro;
      /********************** filtro bloques ********************************/

      this.listanormasfiltro = auxnormas;

      console.log(this.listanormasfiltro);

    }

    onSaveFinalizado(value:boolean){
      this.finalizado = value;
      this.aplicarFiltros();
    }

    onSaveRevisado(value:boolean){
      this.revisado = value;
      this.aplicarFiltros();
    }

    resetAmbitos(){
      this.filtro_id_ambito_nacional = 0;
      this.filtro_id_ambito_internacional = 0;
      this.filtro_id_ambito_autonomico = 0;
      this.filtro_id_ambito_provincial = 0;
      this.filtro_id_ambito_local = 0;
    }

    getListaMarcos(){

      let params = {
        action: "ListagetMarcos"
      }

      this.empresasService.getSelect(params).subscribe(
          data => {
            if (data){
              this.listamarcos = data.json().lista;
            }
          }
      );

    }

    getListaPaises(){

      let params = {
        action: "ListagetPaises"
      }

      this.empresasService.getSelect(params).subscribe(
          data => {
            if (data){
              this.listapaises = data.json().lista;
            }
          }
      );

    }

    getListaComunidades(){

      let params = {
        action: "ListagetComunidades"
      }

      this.empresasService.getSelect(params).subscribe(
          data => {
            if (data){
              this.listacomunidades = data.json().lista;
            }
          }
      );

    }

    getListaProvincias(id_comunidad: any){

      let params = {
        action: "ListagetProvincias",
        id_comunidad: id_comunidad
      }

      this.empresasService.getSelect(params).subscribe(
          data => {
            if (data){
              this.listaprovincias = data.json().lista;
              this.filtro_id_ambito_local = 0;
              this.aplicarFiltros();
            }
          }
      );

    }

    getListaMunicipios(id_provincia: number){

      let params = {
        action: "ListagetMunicipios",
        id_provincia: id_provincia
      }

      this.empresasService.getSelect(params).subscribe(
          data => {
            if (data){
              this.listamunicipios = data.json().lista;
              this.aplicarFiltros();
            }
          }
      );

    }

    getListaBloques(){
      this.normasService.getListaBloques().subscribe(
        data => {
          if (data){
            if (data.json().lista){
              this.listabloques = data.json().lista;
            }
          }
        }
      );
    }

    getListaAreas(id_bloque: number){
      this.normasService.getListaAreas(id_bloque).subscribe(
        data => {
          if (data){
            if (data.json().lista){
              this.listaareas = data.json().lista;
            }
          }
        }
      );
    }

    getListaModulos(id_area:number){
      this.normasService.getListaModulos(id_area).subscribe(
        data => {
          if (data){
            if (data.json().lista){
              this.listamodulos = data.json().lista;
            }
          }
        }
      );
    }

    resetBloques(){
      this.filtro_id_area = 0;
      this.filtro_id_modulo = 0;
    }

//---------------------------------------------------------------------
//-                            FILTROS
//---------------------------------------------------------------------
   
limpiarFiltros(){
   
  this.listaEvidenciasFiltros = [];
  this.getListaEvidencias(this.normaseleccionada);

}

changeValueEvidenciaFiltros(filtro){

 this.listaevidencias = filtro;
 if (filtro.tipo == 'limpiar' ){
   this.limpiarFiltros();      
 }else{
   this.listaevidencias = filtro.value;
 }

 }


}



// WEBPACK FOOTER //
// ./src/app/evidencias/evidenciasin.component.ts